@if (definition && form) {
  <div
    class="soft-list-item-action"
    [formGroup]="form"
    >
    @switch (definition.control) {
      @case ('button') {
        <input
          type="button"
          class="soft-button secondary"
          (click)="onClick()"
          />
      }
      @default {
        <a (click)="onClick()" class="soft-link">
          {{definition.title}}
          <soft-dynamic-value
            [value]="form.value"
            [definition]="definition"
          ></soft-dynamic-value>
        </a>
      }
    }
  </div>
}
